import * as React from 'react';
import { IStatusBadge } from './interfaces';
import { Badge, Chip, ChipProps } from '@mui/material';

export const StatusBadge: React.FC<IStatusBadge> = ({
  label,
  status,
}): JSX.Element => {
  const color: ChipProps['color'] = (() => {
    if (status === 'success') {
      return 'success';
    } else if (status === 'failed') {
      return 'error';
    }

    return 'default';
  })();

  return <Chip label={label} variant="outlined" size="small" color={color} />;
};
